import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { StatisticsData, StatisticsState } from "./types";

const initialState: StatisticsState = {
  data: null,
  loading: false,
  error: null,
  statisticsForSelectedCountry: null,
};

export const fetchStatisticsDataAsync = createAsyncThunk(
  "statistics/fetchStatisticsData",
  async (year: string) => {
    return await api.getStatistics(year);
  }
);

const statisticsSlice = createSlice({
  name: "statistics",
  initialState,
  reducers: {
    clearStatistics: (state) => {
      state.data = initialState.data;
    },
    setStatisticsForSelectedCountry: (
      state,
      action: PayloadAction<StatisticsData | null>
    ) => {
      state.statisticsForSelectedCountry = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStatisticsDataAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStatisticsDataAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchStatisticsDataAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Failed to fetch statistics data";
      });
  },
});

export const { setStatisticsForSelectedCountry } = statisticsSlice.actions;
export default statisticsSlice.reducer;
